import { gql } from '@apollo/client';

export const READ_AVAILABLE_SUBSCRIPTIONS = gql`
  query ReadAvailableSubscriptions($input: CustomerPmcsInput!) {
    readAvailableSubscriptions(input: $input) {
      pmcId
      prices {
        monthlyPrice
        validity {
          validFrom
        }
      }
      description {
        en
        fi
        no
        sv
      }
      billingInterval
      billingTypes
      countryCode
      endSellingDate
      name
      isFirstMonthFree
    }
  }
`;
